const variantSwatches = document.querySelectorAll('.fake_variant-container .variant-swatch');
variantSwatches.forEach((element) => {
    element.addEventListener('click', function () {
        var url = this.getAttribute('data-url');
        if (url) {
            window.location.href = url;
        }
    });
});

const labels = document.querySelectorAll('.fake_variant-container .variant-swatch-label');
const tooltips = document.querySelectorAll('.fake_variant-container .tooltip');

function rgbToHex(rgb) {
    // Sépare les valeurs R, G et B de la chaîne RGB
    var regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
    var match = regex.exec(rgb);
    var r = parseInt(match[1]);
    var g = parseInt(match[2]);
    var b = parseInt(match[3]);

    // Convertit les valeurs R, G et B en hexadécimal
    var hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    // Renvoie la valeur hexadécimale
    return hex;
}

function isLight(color) {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
}

for (let i = 0; i < tooltips.length; i++) {
    let tooltip = tooltips[i];
    let color = tooltip.style.background;
    if (color != '') {
        color = rgbToHex(color);
        if (isLight(color)) {
            tooltip.style.color = '#000';
        }
    }
}

function followPointer(event, swatch) {
    var x = event.clientX,
        y = event.clientY;
    swatch.querySelector('.tooltip').style.top = y + 5 + 'px';
    swatch.querySelector('.tooltip').style.left = x + 10 + 'px';
}

labels.forEach((swatch) => {
    swatch.addEventListener('click', function () {
        selectColor(swatch);
    });
    swatch.addEventListener('mousemove', function (event) {
        followPointer(event, swatch);
    });
});